import React from 'react'
import Footer from '../Components/Footer/Footer'
import HeroSection4 from '../Components/HeroSection4/Hero4'
import ScrollToTop from '../Components/ScrollToTop'
import InfoSection4 from '../Components/Infosection4/Index4'
import { homeObjOne4 } from '../Components/Infosection4/Data4'
import Contact from '../Components/Contact/Contact'

const Wedding = () => {
  return (
    <>
        <ScrollToTop />
        <HeroSection4 />
        <InfoSection4 {...homeObjOne4} />
        <Contact />
        <Footer />
    </>
  )
}

export default Wedding